import { Grid, Typography } from "@mui/material";

const RenderCategoryHead = (): React.JSX.Element => (
  <Grid container spacing={2}>
    <Grid item xs={12} sm={6}></Grid>
    <Grid
      item
      xs={12}
      sm={1}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography variant="caption" color="initial">
        1 Stern
      </Typography>
    </Grid>
    <Grid
      item
      xs={12}
      sm={1}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography variant="caption" color="initial">
        2 Stern
      </Typography>
    </Grid>
    <Grid
      item
      xs={12}
      sm={1}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography variant="caption" color="initial">
        3 Stern
      </Typography>
    </Grid>
    <Grid
      item
      xs={12}
      sm={1}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography variant="caption" color="initial">
        4 Stern
      </Typography>
    </Grid>
    <Grid
      item
      xs={12}
      sm={1}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography variant="caption" color="initial">
        5 Stern
      </Typography>
    </Grid>
    <Grid
      item
      xs={12}
      sm={1}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography variant="caption" color="initial">
        Durchschnitt
      </Typography>
    </Grid>
  </Grid>
);

export default RenderCategoryHead;
